// extracted by mini-css-extract-plugin
module.exports = {"info":"Info_info__70JBY","icon":"Info_icon__rBJy0"};